export enum ErrorCodes {
  duplicatedEntity = 121,
}
